import { render, staticRenderFns } from "./departmentMoneyTable.vue?vue&type=template&id=88d38d5c&scoped=true"
import script from "./departmentMoneyTable.vue?vue&type=script&lang=js"
export * from "./departmentMoneyTable.vue?vue&type=script&lang=js"
import style0 from "./departmentMoneyTable.vue?vue&type=style&index=0&id=88d38d5c&prod&lang=css"
import style1 from "../../statistics/css/moneyTable.css?vue&type=style&index=1&id=88d38d5c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d38d5c",
  null
  
)

export default component.exports